var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "go-channel-content" },
    _vm._l(_vm.accountChannels, function (item, index) {
      return _c("collection-channel-card", {
        key: index,
        attrs: { "account-channel": item },
        on: {
          "account:change": function ($event) {
            return _vm.changeAccount(item)
          },
          "account:unlink": function ($event) {
            return _vm.unlinkAccount(item)
          },
          "agent:update": function (agent) {
            return _vm.updateAgent(item, agent)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }